module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/personality-dark-screens-4-1.9ab4351b.png";